<template>
  <div class="fans" v-title data-title="粉丝管理">
    <!-- <header>
      <img src="../../assets/images/card-img/buy-card-img/icon-24-fanhui.png" alt="" @click="$router.replace('/my')"> 
      <p>
        粉丝管理
      </p>
    </header> -->
    <section>
      <!-- 我的粉丝 -->
      <div class="my-fans">
        <p>
          我的粉丝
        </p>
        <p>
          {{fansNum}}
        </p>
      </div>
      <!-- 粉丝列表 -->
      <div class="fans-list">
        <!-- 粉丝信息 -->
        <div class="fans-msg" v-for="(item,index) in fansList" :key="index">
          <!-- 左侧信息 -->
          <div class="left-msg">
            <div class="herd-img">
              <img :src=item.avatar alt="">
            </div>
            <div class="name-lv">
              <p v-if="item.realname == null">
                {{item.user_nickname}}
              </p>
              <p v-else>
                {{item.realname}}
              </p>
              <p>
                会员等级：1
              </p>
            </div>
          </div>
          <!-- 右侧信息 -->
          <div class="right-msg">
              <p>
                粉丝数：{{item.fansnum}}
              </p>
              <!-- <p>
                消费金额<span>99</span>元
              </p> -->
              <p>
                邀请人：{{realname}}
              </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data(){
    return{
      fansList: [], // 粉丝列表
      fansNum: '', // 粉丝数量
      realname : '', // 邀请人
    }
  },
  created(){
    // 邀请人
    this.realname = this.$route.query.realname
    // 粉丝查询
    this.$axios.get(this.domain.url+"/api/user/public/fans").then((res) => {
      // console.log(res.data.data)
      this.fansList = res.data.data
      // console.log(res.data.data.length)
      this.fansNum = res.data.data.length
    })
  },
  methods:{
    
  }
}
</script>
<style lang="less" scoped>
  .fans{
    width: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      border-bottom: 0.01rem #BFBFBF solid;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      width: 100%;
      height: 100%;
      // flex: 1;
      display: flex;
      flex-direction: column;
      // 我的粉丝
      .my-fans{
        width: 100%;
        height: 1.93rem;
        p{
          &:first-child{
            text-align: center;
            font-size:0.26rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(51,51,51,1);
            line-height: 0.26rem;
            margin-top: .44rem;
          }
          // 数量
          &:last-child{
            text-align: center;
            font-size: 0.6rem;
            font-family: Kozuka Gothic Pr6N;
            font-weight: normal;
            color:rgba(239,130,1,1);
            line-height: .6rem;
            margin-top: .28rem;
          }
        }
      }
      // 粉丝列表
      .fans-list{
        flex: 1;
        width: 100%;
        // height: 100%;
        background: #F0F0F0;
        overflow: scroll;
        // 每一条
        .fans-msg{
          width: 6.9rem;
          height: 1.7rem;
          background: #ffffff;
          border-radius: .2rem;
          margin: 0 auto;
          margin-top: .2rem;
          margin-bottom: .1rem;
          // 左侧
          .left-msg{
            overflow: hidden;
            float: left;
            display: flex;
            // 头像
            .herd-img{
              width: .8rem;
              height: .8rem;
              border-radius: 50%;
              background: #666666;
              margin: .45rem 0 0 .21rem;
              img{
                width: .8rem;
                height: .8rem;
                border-radius: 50%;
              }
            }
            // 名字 等级
            .name-lv{
              margin-left: .13rem;
              p{
                &:first-child{
                  font-size: 0.32rem;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: rgba(51,51,51,1);
                  line-height: .32rem;
                  margin-top: .45rem;
                }
                &:last-child{
                  font-size:0.26rem;
                  font-family:PingFang SC;
                  font-weight:400;
                  color:rgba(153,153,153,1);
                  line-height: .26rem;
                  margin-top: .25rem;
                }
              }
            }
          }
          // 右侧
          .right-msg{
            float: right;
            margin-right: .2rem;
            p{
              text-align: right;
              &:first-child{
                font-size: 0.24rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: rgba(51,51,51,1);
                margin-top: .34rem;
                line-height: .24rem;
              }
              &:nth-child(2){
                font-family: PingFang-SC;
                color: #333333;
                font-size: 0.24rem;
                line-height: .24rem;
                margin-top: .17rem;
                span{
                  color: #EF8201;
                  margin: 0 .1rem 0 .1rem;
                }
              }
              &:last-child{
                font-size: 0.26rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: rgba(153,153,153,1);
                margin-top: .14rem;
                line-height: .26rem;
              }
            }
          }
        }
      }
    }
  }
</style>